import axios from 'axios';

const API_BASE = '/api/expense-reimbursements';

export const expenseReimbursementService = {
  kioskEmployees: async () => {
    const response = await axios.get(`${API_BASE}/kiosk-employees`);
    return response.data;
  },

  kioskSubmit: async ({ file, employeeId, notes, deviceName, amount, receiptDate }) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('employee_id', String(employeeId));
    if (notes) formData.append('notes', notes);
    if (deviceName) formData.append('device_name', deviceName);
    if (amount !== undefined && amount !== null && String(amount).trim() !== '') {
      formData.append('amount', String(amount).trim());
    }
    if (receiptDate) formData.append('receipt_date', receiptDate);

    const response = await axios.post(`${API_BASE}/kiosk`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  getPendingCount: async () => {
    const response = await axios.get(`${API_BASE}/pending-count`);
    return response.data;
  },

  list: async (params = {}) => {
    const response = await axios.get(API_BASE, { params });
    return response.data;
  },

  getById: async (id) => {
    const response = await axios.get(`${API_BASE}/${id}`);
    return response.data;
  },

  getEvents: async (id, params = {}) => {
    const response = await axios.get(`${API_BASE}/${id}/events`, { params });
    return response.data;
  },

  update: async (id, body) => {
    const response = await axios.patch(`${API_BASE}/${id}`, body);
    return response.data;
  },

  delete: async (id) => {
    const response = await axios.delete(`${API_BASE}/${id}`);
    return response.data;
  },

  getImageUrl: (id) => `${API_BASE}/${id}/download`,

  listMine: async (params = {}) => {
    const response = await axios.get(`${API_BASE}/mine`, { params });
    return response.data;
  },

  getMyImageUrl: (id) => `${API_BASE}/mine/${id}/download`,

  submitMine: async ({ file, notes, amount, receiptDate }) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('notes', notes != null ? String(notes).trim() : '');
    formData.append('amount', amount != null ? String(amount).trim() : '');
    if (receiptDate) formData.append('receipt_date', receiptDate);

    const response = await axios.post(`${API_BASE}/mine`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },
};
